import { render, staticRenderFns } from "./distconfig.vue?vue&type=template&id=802b71d6&"
import script from "./distconfig.vue?vue&type=script&lang=js&"
export * from "./distconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports